import React, { useState, useContext } from "react";
import NavBarComponent from "./NavBarComponent";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import PermissionContext from "../Store/permission-context";
import classes from "./MainContainer.module.css";
import { Container } from "react-bootstrap";
import { Link, Switch, Route, Redirect } from "react-router-dom";
import Headroom from "react-headroom";
import HomeComponent from "./pages/HomeComponent";
import NewRegistration from "./pages/NewRegistration";
import ViewUser from "./pages/ViewUser";
import ChangePassword from "./pages/ChangePassword";
import SupplyIn from "./pages/SupplyIn";
import ChangePrice from "./pages/ChangePrice";
import Sales from "./pages/Sales";
import GetReport from "./pages/GetReport";
import GetHistory from "./pages/GetHistory";
import GetSupplyReport from "./pages/GetSupplyReport";
import GetMyReport from "./pages/GetMyReport";
import CashFlow from "./pages/CashFlow";
// import RestoreBackup from "./pages/RestoreBackup";
import Inventory from "./pages/Inventory";
import GoodsReport from "./pages/GoodsReport";
import BackUp from "./pages/BackUp";
import ViewDebts from "./pages/ViewDebts";
import GetCustomerAndExpenditureReport from "./pages/GetCustomerAndExpenditureReport";
import Admin from "./pages/Admin";
import UpdateServer from "./pages/UpdateServer";
import Cookies from "universal-cookie";
import RegisterOrder from "./pages/RegisterOrder";
import ExpiredPage from "./pages/ExpiredPage";

const MainContainer = () => {
  const cookies = new Cookies();
  const PCtx = useContext(PermissionContext);
  const Path = PCtx.ThePath;
  // console.log("The path is: " + Path);
  // console.log("The path is: " + Path);

  const [RoutePage, setRoutePage] = useState([
    { path: "/" + Path, component: HomeComponent },
    { path: "/" + Path + "addnewuser", component: NewRegistration },
    { path: "/" + Path + "viewusers", component: ViewUser },
    { path: "/" + Path + "changepassword", component: ChangePassword },
    { path: "/" + Path + "supplyin", component: SupplyIn },
    { path: "/" + Path + "changeprice", component: ChangePrice },
    { path: "/" + Path + "sales", component: RegisterOrder },
    { path: "/" + Path + "getreport", component: GetReport },
    { path: "/" + Path + "getsupplyreport", component: GetSupplyReport },
    { path: "/" + Path + "myreport", component: GetMyReport },
    { path: "/" + Path + "goodssummary", component: GoodsReport },
    { path: "/" + Path + "viewdebts", component: ViewDebts },
    { path: "/" + Path + "cashflow", component: CashFlow },
    { path: "/" + Path + "updateonline", component: UpdateServer },
    { path: "/" + Path + "orderpayment", component: Sales },
    {
      path: "/" + Path + "customersreports",
      component: GetCustomerAndExpenditureReport,
    },
    { path: "/" + Path + "gethistory", component: GetHistory },
    { path: "/" + Path + "inventory", component: Inventory },
    { path: "/" + Path + "backup", component: BackUp },
    { path: "/" + Path + "admin", component: Admin },
    { path: "/" + Path + "expireditems", component: ExpiredPage },
  ]);

  return (
    <Container fluid className={classes.AllElements} style={{ padding: "0px" }}>
      <ReactNotifications />

      <NavBarComponent />

      {PCtx.logged ? (
        <Switch>
          {RoutePage.map((page, index) => (
            <Route exact {...page} key={index} />
          ))}
        </Switch>
      ) : (
        <Switch>
          <Route path={"/" + Path} component={HomeComponent} />
        </Switch>
      )}
    </Container>
  );
};

export default MainContainer;
